export type CalculationMethodRate = {
  zeroed?: boolean | null;
  percent?: string | null;
  fix?: string | null;
  min?: string | null;
  max?: string | null;
};

export type CalculationMethodStep = {
  commissionRate?: CalculationMethodRate;
};

export type CalculationMethodFormValues = {
  rate?: CalculationMethodRate;
  ladder?: { steps?: CalculationMethodStep[] } | null;
  calculationMethod?: string | null;
};

const hasValue = (value: unknown): boolean => value !== null && value !== undefined && value !== '';

const isRateFilled = (rate?: CalculationMethodRate | null): boolean =>
  !!rate &&
  hasValue(rate.percent) &&
  hasValue(rate.fix) &&
  (hasValue(rate.min) || hasValue(rate.max));

export const isCalculationMethodVisible = (rate?: CalculationMethodRate | null): boolean =>
  !!rate && !rate.zeroed && isRateFilled(rate);

export const isLadderCalculationMethodVisible = (steps?: CalculationMethodStep[] | null): boolean =>
  Array.isArray(steps) && steps.some((step) => isRateFilled(step?.commissionRate));
